import { Link } from 'react-router-dom';
import { Head } from 'vite-react-ssg';
import FooterSection from '../../components/FooterSection';
import { WA_NUMBER } from '../../constant/detail';

const relatedServices = [
  { label: 'Jasa Maintenance Kolam Renang Bali', to: '/jasa-maintenance-kolam-renang-bali' },
  { label: 'Jual Chemical Pool Bali', to: '/jual-chemical-pool-bali' },
  { label: 'Pasang Filter Kolam Renang Bali', to: '/pasang-filter-kolam-renang-bali' },
  { label: 'Jasa Testkit Air Kolam Bali', to: '/jasa-testkit-air-kolam-bali' },
  { label: 'Jual Equipment Pool Bali', to: '/equipment-pool-bali' },
];

const WA_MESSAGE = encodeURIComponent(
  'Halo, saya ingin konsultasi jasa perawatan kolam renang di Ubud'
);

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Jasa Perawatan Kolam Renang di Ubud Bali',
  description:
    'Jasa perawatan kolam renang di Ubud Bali profesional. Melayani villa, hotel, dan resor di Ubud, Tegallalang, Payangan, Kedewatan, dan seluruh Kabupaten Gianyar.',
  provider: {
    '@type': 'LocalBusiness',
    name: 'Pool Shop Surya Jaya Teknik',
    telephone: '+628123618911',
    url: 'https://poolshopsuryajayateknik.com',
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress: 'Jalan Raya Andong, Petulu',
        addressLocality: 'Gianyar',
        addressRegion: 'Bali',
        addressCountry: 'ID',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Jl. Raya Kengetan, Lodtunduh',
        addressLocality: 'Gianyar',
        addressRegion: 'Bali',
        addressCountry: 'ID',
      },
    ],
  },
  areaServed: [
    { '@type': 'City', name: 'Ubud' },
    { '@type': 'City', name: 'Tegallalang' },
    { '@type': 'City', name: 'Payangan' },
    { '@type': 'AdministrativeArea', name: 'Gianyar, Bali' },
  ],
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    opens: '08:00',
    closes: '17:00',
  },
  url: 'https://poolshopsuryajayateknik.com/jasa-perawatan-kolam-renang-ubud',
};

const PerawatanKolamUbud = () => {
  return (
    <>
      <Head>
        <title>Jasa Perawatan Kolam Renang di Ubud Bali | Suryajaya Teknik</title>
        <meta
          name="description"
          content="Jasa perawatan kolam renang di Ubud Bali profesional dan terpercaya. Melayani villa, hotel, dan rumah pribadi di Ubud, Tegallalang, Gianyar, Payangan. Hubungi kami sekarang!"
        />
        <link
          rel="canonical"
          href="https://poolshopsuryajayateknik.com/jasa-perawatan-kolam-renang-ubud"
        />
        <meta property="og:title" content="Jasa Perawatan Kolam Renang di Ubud Bali | Suryajaya Teknik" />
        <meta property="og:description" content="Jasa perawatan kolam renang di Ubud Bali profesional dan terpercaya. Melayani villa, hotel, dan rumah pribadi di Ubud, Tegallalang, Gianyar, Payangan." />
        <meta property="og:url" content="https://poolshopsuryajayateknik.com/jasa-perawatan-kolam-renang-ubud" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify(serviceSchema)}
        </script>
      </Head>

      <main className="mt-16 bg-white text-gray-800">
        {/* Hero */}
        <section className="bg-tertiary text-white py-16 px-6 text-center">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold leading-tight mb-4">
              Jasa Perawatan Kolam Renang di Ubud Bali
            </h1>
            <p className="text-lg md:text-xl text-primary/80 mb-2">
              Profesional &bull; Terpercaya &bull; Berpengalaman
            </p>
            <p className="text-base text-primary/70 mb-8">
              Kolam renang kotor, air hijau, atau pompa bermasalah? Kami hadir dengan solusi
              perawatan kolam renang terlengkap di Ubud dan sekitarnya. Tim teknisi kami
              yang berpengalaman siap menjaga kolam renang Anda tetap bersih, jernih, dan
              aman digunakan sepanjang tahun.
            </p>
            <a
              href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary hover:opacity-90 text-tertiary font-semibold py-3 px-8 rounded-full text-lg transition"
            >
              Konsultasi via WhatsApp
            </a>
          </div>
        </section>

        {/* Mengapa penting */}
        <section className="max-w-4xl mx-auto py-14 px-6">
          <h2 className="text-2xl font-bold text-tertiary mb-4">
            Mengapa Kolam Renang di Ubud Perlu Perawatan Rutin?
          </h2>
          <p className="mb-4 leading-relaxed">
            Ubud dikenal sebagai pusat budaya dan wisata Bali yang dikelilingi oleh alam
            hijau, sawah, dan hutan tropis. Kondisi lingkungan yang lembap dan kaya
            vegetasi ini justru menjadi tantangan tersendiri bagi pemilik kolam renang,
            karena daun, debu, serangga, dan spora lumut sangat mudah masuk ke dalam air
            kolam. Tanpa perawatan rutin, air kolam renang di Ubud dapat berubah hijau
            dalam hitungan hari akibat pertumbuhan alga yang dipicu oleh panas matahari
            dan kelembapan tinggi. Ketidakseimbangan pH dan kadar klorin juga berisiko
            menimbulkan iritasi kulit dan mata bagi pengguna kolam. Oleh karena itu,
            perawatan berkala bukan hanya soal estetika, melainkan juga masalah kesehatan
            dan keselamatan pengguna kolam renang.
          </p>
          <p className="leading-relaxed">
            Suryajaya Teknik telah melayani ratusan pemilik kolam renang di wilayah Ubud
            dan sekitarnya selama lebih dari 10 tahun. Kami memahami tantangan unik
            perawatan kolam di kawasan dengan banyak pohon dan vegetasi lebat seperti
            Ubud, Tegallalang, Payangan, dan Kedewatan. Klien kami di kawasan ini
            mencakup properti ternama seperti The Kayon Ubud, Bebek Tepi Sawah,
            Villa Agung Khalia, dan Ubud Tropical — properti-properti yang menuntut
            standar kejernihan air kolam tertinggi sepanjang tahun. Setiap kunjungan
            kami dilengkapi dengan peralatan profesional dan laporan kondisi kolam yang
            transparan sehingga pemilik selalu tahu kondisi kolam renang mereka secara
            detail. Kami menyesuaikan jadwal perawatan dengan kebutuhan spesifik Anda,
            mulai dari mingguan hingga bulanan, dengan harga yang kompetitif dan jujur
            tanpa biaya tersembunyi.
          </p>
        </section>

        {/* Layanan */}
        <section className="bg-primary/10 py-14 px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold text-tertiary mb-4">
              Layanan Perawatan Kolam Renang di Ubud
            </h2>
            <p className="mb-6 leading-relaxed">
              Kami menyediakan layanan perawatan kolam renang yang komprehensif dan dapat
              disesuaikan dengan kebutuhan villa, hotel, resor, maupun rumah pribadi di
              kawasan Ubud dan Gianyar. Setiap paket layanan dirancang untuk menjaga
              kolam renang Anda dalam kondisi prima dan aman digunakan kapan saja.
              Teknisi kami datang tepat waktu dengan membawa semua perlengkapan dan
              bahan kimia yang diperlukan. Kami juga memberikan rekomendasi teknis jika
              ditemukan tanda-tanda kerusakan pada sistem kolam renang Anda.
            </p>
            <ul className="space-y-3">
              {[
                'Pembersihan manual dinding, lantai, dan permukaan kolam',
                'Pengukuran dan penyeimbangan pH air kolam secara berkala',
                'Penambahan klorin dan bahan kimia kolam sesuai kebutuhan',
                'Pemeriksaan dan servis pompa sirkulasi air',
                'Pembersihan filter pasir, cartridge, atau DE filter',
                'Penanganan air kolam hijau atau keruh akibat alga',
                'Pemeriksaan sistem perpipaan dan deteksi kebocoran',
                'Pembersihan skimmer dan saluran pembuangan',
                'Laporan kondisi kolam setelah setiap kunjungan via WhatsApp',
                'Konsultasi gratis pemilihan bahan kimia yang tepat',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="text-tertiary font-bold mt-0.5">✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* Area layanan */}
        <section className="max-w-4xl mx-auto py-14 px-6">
          <h2 className="text-2xl font-bold text-tertiary mb-4">
            Area Layanan Kami di Ubud dan Sekitarnya
          </h2>
          <p className="mb-6 leading-relaxed">
            Kami melayani jasa perawatan kolam renang di seluruh wilayah Ubud dan daerah
            sekitarnya. Dengan dua lokasi toko kami — di Jalan Raya Andong, Petulu dan
            di Jl. Raya Kengetan, Lodtunduh — kami mampu menjangkau kawasan Ubud dan
            sekitarnya dengan cepat dan efisien, bahkan untuk panggilan mendadak.
            Berikut adalah area yang kami layani secara rutin:
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
            {[
              'Ubud', 'Tegallalang', 'Payangan',
              'Kedewatan', 'Mas', 'Lodtunduh',
              'Peliatan', 'Petulu', 'Campuhan',
              'Sanggingan', 'Sayan', 'Penestanan',
              'Monkey Forest', 'Kemenuh', 'Kengetan',
              'Gianyar Kota',
            ].map((area, i) => (
              <div
                key={i}
                className="bg-white border border-primary/30 rounded-lg px-4 py-2 text-center text-sm font-medium text-tertiary"
              >
                {area}
              </div>
            ))}
          </div>
          <p className="leading-relaxed text-sm text-gray-600">
            Tidak menemukan area Anda? Hubungi kami untuk konfirmasi ketersediaan layanan
            di lokasi Anda. Kami terus memperluas jangkauan layanan ke seluruh Kabupaten
            Gianyar dan wilayah Bali lainnya.
          </p>
        </section>

        {/* Keunggulan */}
        <section className="bg-primary/10 py-14 px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold text-tertiary mb-6">
              Mengapa Memilih Suryajaya Teknik untuk Perawatan Kolam di Ubud?
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                {
                  title: 'Teknisi Berpengalaman',
                  desc: 'Tim kami telah menangani ratusan kolam renang di kawasan Ubud dan Gianyar selama lebih dari satu dekade. Kami memahami tantangan unik perawatan kolam di lingkungan tropis dengan vegetasi lebat.',
                },
                {
                  title: 'Harga Transparan',
                  desc: 'Tidak ada biaya tersembunyi. Estimasi harga diberikan sebelum pekerjaan dimulai. Kami percaya kejujuran adalah fondasi kepercayaan jangka panjang bersama pelanggan.',
                },
                {
                  title: 'Jadwal Fleksibel',
                  desc: 'Tersedia setiap hari termasuk akhir pekan dan hari libur nasional. Kami menyesuaikan jadwal kunjungan dengan aktivitas villa atau hunian Anda.',
                },
                {
                  title: 'Bahan Kimia Tersertifikasi',
                  desc: 'Kami hanya menggunakan bahan kimia kolam yang memenuhi standar keamanan internasional dan aman untuk kulit serta lingkungan sekitar kolam Anda.',
                },
                {
                  title: 'Garansi Kepuasan Kerja',
                  desc: 'Setiap pekerjaan disertai garansi kepuasan. Jika kolam belum sesuai standar, kami akan kembali tanpa biaya tambahan hingga hasilnya memuaskan.',
                },
                {
                  title: 'Laporan Digital via WA',
                  desc: 'Pelanggan menerima laporan kondisi kolam lengkap beserta foto melalui WhatsApp setelah setiap kunjungan, sehingga Anda selalu tahu kondisi kolam meski sedang tidak di lokasi.',
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="bg-white border border-primary rounded-xl p-5 shadow-sm"
                >
                  <h3 className="font-semibold text-tertiary mb-2">{item.title}</h3>
                  <p className="text-gray-600 text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="max-w-4xl mx-auto py-14 px-6">
          <h2 className="text-2xl font-bold text-tertiary mb-6">
            Pertanyaan Umum Seputar Perawatan Kolam Renang di Ubud
          </h2>
          <div className="space-y-6">
            {[
              {
                q: 'Berapa biaya jasa perawatan kolam renang di Ubud?',
                a: 'Biaya perawatan kolam renang di Ubud bervariasi tergantung ukuran kolam, frekuensi kunjungan, dan kondisi kolam saat ini. Kami menawarkan paket perawatan mingguan dan bulanan dengan harga kompetitif. Hubungi kami untuk mendapatkan penawaran harga yang disesuaikan dengan kebutuhan kolam Anda.',
              },
              {
                q: 'Seberapa sering kolam renang di Ubud perlu dirawat?',
                a: 'Di kawasan Ubud yang memiliki banyak vegetasi dan kelembapan tinggi, kami merekomendasikan perawatan minimal seminggu sekali untuk menjaga kejernihan air dan keseimbangan kimia kolam. Untuk kolam yang jarang digunakan atau berada di bawah pohon rindang, perawatan dua kali seminggu mungkin diperlukan.',
              },
              {
                q: 'Apakah Anda bisa menangani air kolam yang sudah hijau atau keruh?',
                a: 'Ya, kami memiliki pengalaman menangani berbagai kondisi kolam termasuk air hijau akibat alga, air keruh, dan water staining. Proses penanganan meliputi super chlorination (shock treatment), pembersihan mekanis menyeluruh, penyesuaian kimia air, dan pembersihan filter. Biasanya kolam dapat kembali jernih dalam 1-3 hari tergantung tingkat keparahannya.',
              },
              {
                q: 'Apakah Anda melayani villa dan hotel di Ubud?',
                a: 'Tentu. Kami memiliki pengalaman luas dalam menangani kolam renang di villa, hotel, resor, dan penginapan di kawasan Ubud dan Gianyar. Kami dapat menyesuaikan jadwal perawatan dengan operasional bisnis Anda agar tidak mengganggu tamu.',
              },
            ].map((item, i) => (
              <div key={i} className="border border-gray-200 rounded-xl p-5">
                <h3 className="font-semibold text-tertiary mb-2">{item.q}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Jasa Bersih Kolam Renang Ubud */}
        <section className="max-w-4xl mx-auto py-14 px-6">
          <h2 className="text-2xl font-bold text-tertiary mb-4">
            Jasa Bersih Kolam Renang di Ubud — Layanan Lengkap, Bukan Setengah-Setengah
          </h2>
          <p className="mb-4 leading-relaxed">
            Bagi villa dan properti di kawasan Ubud yang mencari <strong>jasa bersih kolam renang di Ubud</strong>, kami menawarkan layanan pembersihan kolam yang menyeluruh dan terstruktur. Setiap kunjungan mencakup pembersihan fisik lengkap — vakum lantai kolam, sikat dinding dan waterline dari noda frangipani dan alga, bersihkan skimmer basket, backwash filter jika tekanan sudah tinggi, dan buang semua debris organik dari permukaan air. Tidak ada yang dilewatkan.
          </p>
          <p className="leading-relaxed">
            Yang membedakan jasa bersih kolam renang kami dari sekadar tukang bersih biasa: setiap kunjungan diakhiri dengan pengujian dan penyeimbangan kimia air secara lengkap. Air kolam di Ubud dengan banyak vegetasi sekitar cenderung cepat berubah pH akibat masuknya material organik. Kami pastikan setiap selesai pembersihan, air kolam Anda dalam kondisi kimia yang tepat — jernih secara visual sekaligus aman secara kimiawi. Laporan kondisi dikirimkan via WhatsApp setelah setiap kunjungan.
          </p>
        </section>

        {/* CTA */}
        <section className="bg-tertiary text-white py-16 px-6 text-center">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold mb-4">
              Butuh Jasa Perawatan Kolam Renang di Ubud?
            </h2>
            <p className="text-primary/80 mb-8">
              Hubungi kami sekarang untuk konsultasi gratis dan penawaran harga terbaik.
              Tim kami siap membantu menjaga kolam renang Anda tetap bersih, jernih, dan
              aman digunakan kapan saja. Jangan tunggu sampai masalah membesar — hubungi
              Suryajaya Teknik dan rasakan perbedaannya.
            </p>
            <a
              href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary hover:opacity-90 text-tertiary font-semibold py-3 px-10 rounded-full text-lg transition"
            >
              Hubungi Kami via WhatsApp
            </a>
          </div>
        </section>

        {/* Related Services */}
        <section className="max-w-4xl mx-auto py-10 px-6">
          <h2 className="text-lg font-bold text-tertiary mb-4">Layanan Lainnya</h2>
          <div className="flex flex-wrap gap-3">
            {relatedServices.map(({ label, to }) => (
              <Link key={to} to={to} className="text-sm font-medium text-primary border border-primary/40 px-4 py-2 rounded-full hover:bg-primary/10 transition">
                {label}
              </Link>
            ))}
          </div>
        </section>

        <FooterSection />
      </main>
    </>
  );
};

export default PerawatanKolamUbud;
